import { render, staticRenderFns } from "./RsaAccettazioneImpegnativaEditComponent.vue?vue&type=template&id=0ebbfaca"
import script from "./RsaAccettazioneImpegnativaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneImpegnativaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports